var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('transition-group',{staticClass:"grid",attrs:{"name":"list","mode":"out-in"}},_vm._l((_vm.availableDoors),function(door){return _c('grid-item',{key:door.id,attrs:{"door":door}})}),1),_c('disclaimer',{staticClass:"grid__disclaimer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }